import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getBrowserRegionDefaults } from '../../../utilities/region';
import { getCurrencyFormatter, getCurrencyParts } from './FormattedCurrency.utils';

export const useFormattedCurrency = (value: number) => {
  const region = useSelector((state: any) => state.region) || {};
  const culture = region.culture || getBrowserRegionDefaults().culture;
  const currency = region.currency || getBrowserRegionDefaults().currency;

  const formatter = useMemo(() => getCurrencyFormatter(culture, currency), [culture, currency]);
  const parts = useMemo(() => getCurrencyParts(formatter, value), [formatter, value]);

  return {
    formatter,
    parts
  };
};
